import React, { useEffect, useRef, useState } from "react";
import PageMenu from "../components/PageMenu";
import { Card, Col, Row } from "react-bootstrap";
import DonutChart from "../../../../../../components/chart/DonutChart";
import IndiaMap from "../../../../../../components/chart/IndiaMap";
import ReactTable from "../../../../../../lib/table/react-table";
import ReactCalender from "../../../../../../components/react-calender/ReactCalender";
import {
  formatPageTitle,
  getCalanderEvents,
  transformDemoMedium,
  transformDemoScheduleStatus,
  transformStateData,
} from "../../utils/commonFunctions";
import { useParams } from "react-router-dom";
import {
  useGetLeadDataFile,
  useGetProjectDetails,
  useGetSummaryCount,
  useGetSummaryInDemoCalendar,
  useGetSummaryInDemoGeography,
  useGetSummaryInDemoHcpDetails,
  useGetSummaryInDemoMediumDemo,
  useGetSummaryInDemoSchedumeStatus,
} from "../../../../../../queries/query-hooks/workspace/emsl-hook";
import SquareChartSkeleton from "../../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import CalendarSkeleton from "../../../../../../skeleton/workspace/clirnet/emsl/calender-skeleton";
import CommonTableLoader from "../../../../../../skeleton/common-table-loader";
import useRedirect from "../../../../../../components/custom-hooks/use-redirect";
import { findIcon } from "../../../../../dashboard/icons";
import useCsvDownloader from "../../../../../../components/custom-hooks/use-csv-downloader";
import dayjs from "dayjs";
import { ProjectHeaderTopBar, TableHeader, CardNotFound } from "@ui";

const InDemo = () => {
  const { project_id } = useParams();
  const { redirectTo } = useRedirect();
  const { downloadCSV } = useCsvDownloader();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);
  const [tableOffset, setTableOffset] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const [showDownload, setShowDownload] = useState(false);
  const [leadId, setLeadId] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleModelClose();
      }
    };
    if (showDownload) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDownload]);

  const contentIds = projectDetails?.content
    ?.map((item) => item?.content_id)
    .join(",");

  const { data: summaryCount, isLoading: isSummaryCountLoading } =
    useGetSummaryCount(project_id, {
      start_date: projectDetails?.project_start_date,
      end_date: projectDetails?.project_end_date,
      content_id: contentIds,
    });

  const payload = {
    start_date: projectDetails?.project_start_date,
    end_date: projectDetails?.project_end_date,
    content_id: contentIds,
  };
  const tablePayload = {
    start_date: projectDetails?.project_start_date,
    end_date: projectDetails?.project_end_date,
    content_id: contentIds,
    masked_data: true,
    offset: tableOffset,
    limit: summaryCount?.interactions,
  };

  const { data: scheduleStatus, isLoading: isScheduleStatusLoading } =
    useGetSummaryInDemoSchedumeStatus(project_id, payload);
  const { data: mediumDemo, isLoading: isMediumDemoLoading } =
    useGetSummaryInDemoMediumDemo(project_id, payload);
  const { data: geography, isLoading: isGeographyLoading } =
    useGetSummaryInDemoGeography(project_id, payload);
  const { data: calenderData, isLoading: isCalenderLoading } =
    useGetSummaryInDemoCalendar(project_id, payload);
  const { data: maskedHcpDetails, isLoading: isMaskedhcpDetailsLoading } =
    useGetSummaryInDemoHcpDetails(project_id, tablePayload);
  const { data: leadDataFile, isLoading: isLeadDataFileLoading } =
    useGetLeadDataFile(project_id, !!leadId, leadId);
  const [searchText, setSearchText] = useState("");
  const [maskedType, setMaskedType] = useState(true);

  const totalCount = maskedHcpDetails?.totalCount || 0;

  const { data: unMaskedHcpDetails, isLoading: isUnMaskedHcpDetailsLoading } =
    useGetSummaryInDemoHcpDetails(project_id, {
      ...tablePayload,
      offset: 0,
      limit: summaryCount?.interactions,
      masked_data: maskedType,
    });

  useEffect(() => {
    if (!isUnMaskedHcpDetailsLoading && maskedType === false) {
      downloadCSV(hcpTableCsvFormat);
      setMaskedType(true);
    }
  }, [unMaskedHcpDetails, isUnMaskedHcpDetailsLoading]);

  const filteredhcpDetails = maskedHcpDetails?.rows?.filter(
    (hcp) =>
      hcp?.state?.toLowerCase().includes(searchText?.toLowerCase()?.trim()) ||
      hcp?.device?.toLowerCase().includes(searchText?.toLowerCase()?.trim()) ||
      hcp?.browser?.toLowerCase().includes(searchText?.toLowerCase()?.trim())
  );

  const LOCATION_REPORT_TABLE_COLUMNS = [
    {
      columnId: 1,
      Header: "Name",
      accessor: "name",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 2,
      Header: "Specialty",
      accessor: "speciality",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 3,
      Header: "State",
      accessor: "state",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 4,
      Header: "Device",
      accessor: "device",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 5,
      Header: "Browser",
      accessor: "browser",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return value.value;
      },
    },
    {
      columnId: 6,
      Header: "Demo Platform",
      accessor: "demo_platform",
      disableFilters: true,
      Cell: (value) => {
        if (!value.value) return "---";
        return formatPageTitle(value.value);
      },
    },
    {
      columnId: 7,
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row }) => {
        const redirectURL = `emsl/summary/interactions/${project_id}/leads/details/${row.original.doctor_master_id}`;
        return (
          <>
            <div className="d-flex justify-content-center align-items-center gap-3">
              <i
                className="rounded-pill text-secondary text-center cursor-pointer"
                onClick={() => redirectTo(redirectURL)}
              >
                {findIcon("Eye", "solid", 30)}
              </i>
              <i
                className="rounded-pill text-success text-center cursor-pointer"
                onClick={() => {
                  setLeadId(row.original.doctor_master_id);
                  setShowDownload(true);
                }}
              >
                {findIcon("download", "solid", 24)}
              </i>
            </div>
          </>
        );
      },
    },
  ];

  const hcpTableCsvFormat = {
    header: [
      "Name",
      "Specialty",
      "State",
      "Device",
      "Browser",
      "Demo Platform",
    ],
    column: [
      "name",
      "speciality",
      "state",
      "device",
      "browser",
      "demo_platform",
    ],
    rows: unMaskedHcpDetails?.rows,
  };

  const exportCSV = () => {
    setMaskedType(false);
  };

  const formattedDemoScheduleStatusData =
    transformDemoScheduleStatus(scheduleStatus);
  const formattedMediumOfDemoData = transformDemoMedium(mediumDemo);
  const formattedEventsData = getCalanderEvents(calenderData);
  const formattedGeographyData = transformStateData(geography);

  const isEmptyGraph = (data = []) => {
    return (
      Array.isArray(data) &&
      data.length > 0 &&
      data.every((item) => item.count === 0)
    );
  };

  const onTableStateChange = (e) => {
    setCurrentPageNumber(e?.pageIndex);
    setTableOffset(e?.pageIndex * 10);
  };

  function handleModelClose() {
    setLeadId(null);
    setShowDownload(false);
  }
  const handleDownload = (fileUrl) => {
    window.open(fileUrl, "_blank");
  };

  return (
    <div className="mb-3">
      <ProjectHeaderTopBar
        projectType="eMSL"
        title="Interactions"
        projectStartDate={projectDetails?.project_start_date || ""}
        projectEndDate={projectDetails?.project_end_date || ""}
        status={projectDetails?.status}
        isProjectDetailsLoading={isProjectDetailsLoading}
      />
      <PageMenu name="interactions" />
      <Row className="mb-3 mb-md-4">
        <Col className="d-flex flex-column" md={4} sm={12}>
          {!isScheduleStatusLoading &&
          scheduleStatus?.length > 0 &&
          !isEmptyGraph(scheduleStatus) ? (
            <DonutChart
              title={`Schedule Status`}
              labels={formattedDemoScheduleStatusData.labels}
              series={formattedDemoScheduleStatusData.series}
              graphColor={[
                "#3256BB",
                "#637EC8",
                "#95A7D8",
                "#C6CFE8",
                "#E5E9F2",
              ]}
              height={320}
            />
          ) : isScheduleStatusLoading ? (
            <SquareChartSkeleton height={320} />
          ) : (
            <CardNotFound
              title={`Schedule Status`}
              isTitleCenter={true}
              height={360}
            />
          )}
        </Col>
        <Col className="d-flex flex-column" md={4} sm={12}>
          {!isMediumDemoLoading &&
          mediumDemo?.length > 0 &&
          !isEmptyGraph(mediumDemo) ? (
            <DonutChart
              title={`Medium of demo`}
              labels={formattedMediumOfDemoData.labels}
              series={formattedMediumOfDemoData.series}
              graphColor={[
                "#3256BB",
                "#637EC8",
                "#95A7D8",
                "#C6CFE8",
                "#E5E9F2",
              ]}
              height={320}
            />
          ) : isMediumDemoLoading ? (
            <SquareChartSkeleton height={320} />
          ) : (
            <CardNotFound
              title={`Medium of demo`}
              isTitleCenter={true}
              height={360}
            />
          )}
        </Col>
        <Col className="d-flex flex-column" md={4} sm={12}>
          {!isGeographyLoading && geography?.length > 0 ? (
            <IndiaMap
              title={`Geography`}
              stateData={formattedGeographyData}
              showStateLegend={false}
              valueSuffix={"%"}
            />
          ) : isGeographyLoading ? (
            <SquareChartSkeleton height={320} />
          ) : (
            <CardNotFound
              title={`Geography`}
              isTitleCenter={true}
              height={360}
            />
          )}
        </Col>
      </Row>

      <Row>
        {!isCalenderLoading ? (
          <Col className="d-flex flex-column" sm={12}>
            <ReactCalender
              events={formattedEventsData}
              tooltip="View the schedule of your engagement activities for the selected month"
            />
          </Col>
        ) : isCalenderLoading ? (
          <Col className="d-flex flex-column" sm={12}>
            <CalendarSkeleton />
          </Col>
        ) : (
          <CardNotFound title={`Calendar`} />
        )}
      </Row>
      <Row>
        <Col className="d-flex flex-column" sm={12}>
          <Card className="rounded-3">
            <TableHeader
              title="HCP's Details"
              searchProps={{
                isNeeded: true,
                placeholder: "Search via State / Device / Browser",
                searchText: searchText,
                setSearchText: setSearchText,
              }}
              downloadProps={{
                needCsvDownload: true,
                exportCSVHandler: exportCSV,
              }}
            />
            <Card.Body className="position-relative">
              {showDownload ? (
                <>
                  <div
                    className="position-fixed top-0 start-0 w-100 h-100"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 1040,
                    }}
                  ></div>
                  <div
                    ref={modalRef}
                    className={`card mt-2 mb-0 border position-absolute top-50 start-50 translate-middle rounded-3`}
                    style={{
                      maxHeight: "20rem",
                      width: "25rem",
                      zIndex: 1050,
                    }}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center p-3 mb-0"
                      style={{ backgroundColor: "#d1d1d14d" }}
                    >
                      <span className="poppins-medium text-dark">
                        Download Report
                      </span>
                      <span
                        className="fc-icon fc-icon-x cursor-pointer"
                        title="Close"
                        onClick={handleModelClose}
                      ></span>
                    </div>
                    <div
                      className={`${
                        leadDataFile?.length > 3 ? "overflow-y-scroll" : ""
                      }`}
                    >
                      {!isLeadDataFileLoading && leadDataFile?.length > 0 ? (
                        leadDataFile?.map((item, index) => {
                          const createdAt = dayjs(item?.created_at).format(
                            "DD-MM-YYYY . h:mmA"
                          );
                          const taskTypeName = item?.task?.task_type?.name;
                          return (
                            <div
                              key={`lead_data_file_${index}`}
                              className="m-2 px-2 py-1 rounded-1 border-bottom"
                            >
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex gap-2 align-items-center">
                                  <div>{findIcon("file", "solid", 30)}</div>
                                  <div className="d-flex flex-column justify-content-center">
                                    <p
                                      className="m-0 poppins-medium text-capitalize"
                                      style={{ color: "#525252" }}
                                    >
                                      {taskTypeName}
                                    </p>
                                    <p className="m-0">{createdAt}</p>
                                  </div>
                                </div>
                                <div
                                  className="text-success cursor-pointer"
                                  onClick={() => handleDownload(item.file)}
                                >
                                  {findIcon("DownloadReport", "dual-tone", 24)}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : isLeadDataFileLoading ? (
                        <p className="m-2 px-2 py-1">Loading...</p>
                      ) : (
                        <p className="m-2 px-2 py-1">No data found</p>
                      )}
                    </div>
                  </div>
                </>
              ) : null}
              {!isMaskedhcpDetailsLoading ? (
                <ReactTable
                  data={
                    Array.isArray(filteredhcpDetails) ? filteredhcpDetails : []
                  }
                  columns={LOCATION_REPORT_TABLE_COLUMNS}
                  recordsTotal={totalCount}
                  isPaginationShow={false}
                  currentPageNumber={currentPageNumber}
                  bordered
                  contentCenter
                  noDataText="No Data Available"
                  onTableStateChange={onTableStateChange}
                />
              ) : (
                <CommonTableLoader
                  tableRowLength={5}
                  hasSearch={false}
                  hasActions={false}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default InDemo;
